
      import Email from './email.vue'
      import type { App, Plugin } from 'vue'

      export const EmailPlugin: Plugin = {
        install(app: App) {
          app.component('Email', Email)
        },
      }
      export { Email }
      